import { History } from "./History.js";
import { HistoryRules } from "./HistoryRules.js";
// TODO add tests
// TODO add decorator to avoid tracking some properties
export class HistoryManager extends History {
    constructor() {
        super(...arguments);
        this._target = null;
        this._clonedTarget = null;
    }
    setModels(bindedModel, appModel) {
        this._bindedModel = bindedModel;
        this._appModel = appModel;
    }
    startTracking(target) {
        if (this._target)
            throw new Error("HistoryManager: Cannot initialize state while another state is being tracked.");
        target = target ? [target, this._bindedModel, this._appModel] : [this._bindedModel, this._appModel];
        this._target = target;
        this._clonedTarget = this.deepClone(target);
    }
    detectChanges() {
        if (!this._target)
            return;
        const state = this.checkDiff(this._target, this._clonedTarget);
        this.add(state);
        this._target = null;
        this._clonedTarget = null;
    }
    deepClone(target, seen = new Map()) {
        if (seen.has(target))
            return seen.get(target); // evita ricorsione infinita
        const clone = Array.isArray(target) ? [] : {};
        seen.set(target, clone);
        let excludeSet = null;
        let includeArray;
        for (const rule of HistoryRules) {
            if (rule.isCallback(target)) {
                excludeSet = rule.exclude;
                includeArray = rule.include;
                break;
            }
        }
        let keys = Object.keys(target);
        if (includeArray) {
            keys = [...keys, ...includeArray];
        }
        for (const key of keys) {
            if (excludeSet?.has(key))
                continue;
            const value = target[key];
            if (value) {
                if (typeof value === 'function')
                    continue; // ignora le funzioni (callback)
                if (value.__skipHistory)
                    continue; // fix iPad undo bug due to onLeave doesn't dispose donut correctly
                if (value.isQuaternion)
                    continue; // ignora le Quaternion (callback) because there's already the euler, and they are synced
                if (value.isCachedMeasure)
                    continue; // ignora le cachedMeasure (callback)
                if (value.isLinePointToPoint)
                    continue; // ignora le LinePointToPoint (callback)
                if (value.isLinePointToPoint2)
                    continue; // ignora le LinePointToPoint2 (callback)
                const isImage = value instanceof HTMLImageElement;
                if (value instanceof HTMLElement && !isImage)
                    continue; // TODO ignora gli elementi DOM che non siano immagini. This can be remove it we implement the ignore attribute to the label
                if (typeof value === 'object' && !isImage) {
                    clone[key] = this.deepClone(value, seen);
                    continue;
                }
            }
            clone[key] = value;
        }
        return clone;
    }
    checkDiff(src, cloned, states = [], seen = new Set(), force = false) {
        // here we are not checking the new properties added to the object
        if (seen.has(src))
            return states; // avoid infinite recursion
        seen.add(src);
        let state = null;
        for (const key in cloned) {
            const oldValue = cloned[key];
            const currentValue = src[key];
            if (force) { // only vec3 and quaternion
                state = this.updateState(src, key, oldValue, state);
                continue;
            }
            const isImage = currentValue instanceof HTMLImageElement;
            if (typeof oldValue !== typeof currentValue) {
                if (currentValue?.__skipHistory || oldValue?.__skipHistory)
                    continue; // fix iPad undo bug due to onLeave doesn't dispose donut correctly
                // TODO improve handling of type mismatch
                console.warn(`HistoryManager: Property type mismatch for key "${key}". Old value type: ${typeof oldValue}, Current value type: ${typeof currentValue}`);
                state = this.updateState(src, key, oldValue, state);
            }
            else if (oldValue !== null && typeof oldValue === 'object' && !isImage) {
                if (oldValue.isVector3 || oldValue.isEuler) {
                    this.checkDiff(currentValue, oldValue, states, seen, true);
                }
                else {
                    this.checkDiff(currentValue, oldValue, states, seen);
                }
            }
            else if (oldValue !== currentValue) {
                state = this.updateState(src, key, oldValue, state);
            }
        }
        if (state !== null)
            states.push(state);
        return states;
    }
    updateState(target, key, oldValue, state) {
        state ?? (state = { target, props: {} });
        state.props[key] = oldValue;
        return state;
    }
}
//# sourceMappingURL=HistoryManager.js.map